import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <div className="bg-light border-bottom mb-4">
      <Container>
        <div className="d-flex justify-content-between align-items-center py-3">
          <div className="d-flex align-items-center">
            <h4 className="m-0">Total Remuneration Management</h4>
          </div>
          
          {isAuthenticated && user && (
            <div className="d-flex align-items-center">
              <span className="me-3">
                {user.displayName || user.email}
              </span>
              <Button 
                variant="outline-danger" 
                size="sm"
                onClick={logout}
              >
                Logout
              </Button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Header; 